import { Paper } from "@mui/material";
import Draggable from "react-draggable";
import { useRef } from "react";
import styled from "styled-components";

const API_URL = "http://api-dulichdienban.fixcom.vn";
// const API_URL = window.location.origin.replace(":8084", ":8083");
// const APP_URL = "http://dulichdienban.fixcom.vn";
const APP_URL = "http://10.0.0.170:8085";

const ClientId_Google =
  "1035584860099-rjcmen7v3e1d1k7t95tokcuo225thpbl.apps.googleusercontent.com";

export const API_URL_DOWNLOAD = "http://api-dulichdienban.fixcom.vn/media/";
export const CODE_DANANG = 48;
export const CODE_DIENBAN = 507;

export const MAX_UPLOAD_SIZE = 200 * 1024 * 1024;
export const MAX_UPLOAD_SIZE_3D = 300 * 1024 * 1024;

export const API_MAPBOX_TOKEN =
  "pk.eyJ1IjoiZml4Y29tIiwiYSI6ImNtYWt5dDFldjAzNDgya3Nmanh4NXoxdHEifQ.EFZTkrMCmPOGyE_OpWcjxw";
export const centerInitial = [108.2549431, 15.8881494];

export const API_ROUTES = {
  BASE_URL: `${API_URL}/api/v1`,
  REFRESH_TOKEN: `${API_URL}/api/v1/refresh-token`,
  RESET_PASSWORD: `${API_URL}/api/v1/password_reset`,
  TINH: `${API_URL}/api/v1/tinh`,
  GETHUYEN: `${API_URL}/api/v1/tinh/huyen`,
  GETXA: `${API_URL}/api/v1/huyen/xa`,
  LOAIVANBAN: `${API_URL}/api/v1/loaivanban`,
  USER: `${API_URL}/api/v1/user`,
  LISTUSER: `${API_URL}/api/v1/listusers`,
  DASHBOARD: `${API_URL}/api/v1/dashboard`,
  TRANGTHAI: `${API_URL}/api/v1/trangthai`,
  DANTOC: `${API_URL}/api/v1/dantoc`,
  QUOCGIA: `${API_URL}/api/v1/quocgia`,
  ALLHUYEN: `${API_URL}/api/v1/tinh/huyen?tinh=${CODE_DANANG}`,
  ALLXA: `${API_URL}/api/v1/huyen/xa?tinh=${CODE_DANANG}`,
  VANBAN: `${API_URL}/api/v1/vanban`,
  ICON: `${API_URL}/api/v1/icon`,
  TINTUC: `${API_URL}/api/v1/tintuc`,
  GIOITHIEU: `${API_URL}/api/v1/gioithieu`,
  FEEDBACK: `${API_URL}/api/v1/feedback`,
  KHUDITICH: `${API_URL}/api/v1/khuditich`,
  PHONGTRUNGBAY: `${API_URL}/api/v1/phongtrungbay`,
  MAUVAT: `${API_URL}/api/v1/mauvat`,
  NHOMSANPHAM: `${API_URL}/api/v1/nhomsanpham`,
  SANPHAM: `${API_URL}/api/v1/sanpham`,
  DOANHNGHIEP: `${API_URL}/api/v1/doanhnghiep`,
  phongban: `${API_URL}/api/v1/department`,
  LOAIDITICH: `${API_URL}/api/v1/loaiditich`,
  LOAIMAUVAT: `${API_URL}/api/v1/loaimauvat`,
  DICHVU: `${API_URL}/api/v1/dichvu`,
  LOAIDIADIEM: `${API_URL}/api/v1/loaidiadiem`,
  DIADIEM: `${API_URL}/api/v1/diadiem`,
  NEWDIADIEM: `${API_URL}/api/v12/diadiem`,
  LOAIHINHDOANHNGHIEP: `${API_URL}/api/v1/loaihinhdoanhnghiep`,
  LINHVUCDAUTU: `${API_URL}/api/v1/linhvucdautu`,
  DUAN: `${API_URL}/api/v1/duan`,
  DOUUTIEN: `${API_URL}/api/v1/douutien`,
  LOAIDUAN: `${API_URL}/api/v1/loaiduan`,
  NHOMDUAN: `${API_URL}/api/v1/nhomduan`,
  NHOMNGANHNGHE: `${API_URL}/api/v1/nhomnganhnghe`,
  NGANHNGHE: `${API_URL}/api/v1/nganhnghe`,
  CHUYENNHUONGDUAN: `${API_URL}/api/v1/chuyennhuongduan`,
  KHUCUMCONGNGHIEP: `${API_URL}/api/v1/khucumcongnghiep`,
  LOAIKHUCUMCONGNGHIEP: `${API_URL}/api/v1/loaikhucum`,
  HINHTHUCDAUTU: `${API_URL}/api/v1/hinhthucdautu`,
  TRANGTHAIDUAN: `${API_URL}/api/v1/trangthaiduan`,
  BANDONEN: `${API_URL}/api/v1/bandonen`,
  NGONNGU: `${API_URL}/api/v1/ngonngu`,
  IMAGE: `${API_URL}/api/v1/imageslide`,
  BINHLUAN: `${API_URL}/api/v1/binhluan`,
  TOUR: `${API_URL}/api/v1/tours`,
  TOURV2: `${API_URL}/api/v2/tours`,
  SETTING: `${API_URL}/api/v1/setting`,
  ACTIONLOG: `${API_URL}/api/v1/actionlog`,
  EXTENSIONFILE: `${API_URL}/api/v1/extension`,
  READFILEMEDIA: `${API_URL}/api/v1/read-file-media`,
};

export const API_ROUTES_V2 = {
  DETAILHUYEN: `${API_URL}/api/v2/gethuyen/{code}`,
  DETAILXA: `${API_URL}/api/v2/getxa/{code}`,
  DIADIEM: `${API_URL}/api/v2/diadiem`,
  TINH: `${API_URL}/api/v2/tinh`,
  PHUONGXA: `${API_URL}/api/v2/phuongxa`,
};

export const APP_ROUTES = {
  SIGN_IN: "/authentication/sign-up",
  DASHBOARD: "/dashboard",
};

export const LINK_API = {
  allTinh: "tinh",
  getHuyen: "tinh/{id}/huyen",
  getXa: "huyen/{id}/xa",
};

export const PermissionMenuKey = {
  csdlthuongmai: "csdlthuongmai",
  home: "home",
  dashboard: "dashboard",
  users: "users",
  roles: "roles",
  menu: "menu",
  groupMenu: "groupmenu",
  //Danh mục
  danhmucDulich: "danhmucdulich",
  donViHanhChinh: "donvihanhchinh",
  loaiHinhDoanhNghiep: "loaihinhdn",
  linhVucDautu: "linhvucdautu",
  nhomDuAn: "nhomduan",
  loaiDuAn: "loaiduan",
  loaiHinhKD: "loaihinhkd",
  nhomNganh: "nhomnganhnghe",
  nganhNghe: "nganhnghe",
  trangThai: "trangthai",
  doUutien: "douutien",
  phongBan: "phongban",
  loaiMauVat: "loaimauvat",
  quanlyvanban: "quanlyvanban",
  dulich: "dulich",
  diadiem: "diadiem",
  loaidiadiem: "loaidiadiem",
  // du lịch
  quanlyKhuditich: "khuditich",
  Relics: "relics",
  Place: "place",
  Company: "company",
  Gallery: "gallery",
  Discover: "discover",
  loaiDitich: "loaiditich",
  phongTrungbay: "phongtrungbay",
  mauVat: "mauvat",
  dichVu: "dichvu",
  sanPham: "sanpham",
  nhomsanPham: "nhomsanpham",
  doanhNghiep: "doanhnghiep",
  duAn: "duan",
  chuyenNhuongDuAn: "chuyennhuongduan",
  lichSuDuAn: "lichsuduan",
  banDoSo: "bandoso",
  diaDiemDulich: "diadiemdulich",
  quanlysolieu: "quanlysolieu",
  tinTuc: "tintuc",
  chiTietTinTuc: "chitiettintuc",
  chiTietDiaDiem: "chitietdiadiem",
  gioiThieu: "gioithieu",
  gopY: "gopy",
  quanLyTinTuc: "quanlytintuc",
  quanLyGioiThieu: "quanlygioithieu",
  ngonNgu: "ngonngu",
  lopbandoNen: "bandonen",
  lopbando3D: "thongtinmodel3d",
  loaihinhDulich: "loaihinhdulich",
  Tour: "tours",
  Stop: "stops",
  setting: "setting",
  actionLog: "actionlog",
  extensionFile: "extensionfile",
  share: "share",
};

export const routeToSidebarItem = {
  "": "PLACE",
  "/": "PLACE",
  [`/${PermissionMenuKey.Relics}`]: "MUSEUM",
  [`/${PermissionMenuKey.Company}`]: "COMPANY",
  [`/${PermissionMenuKey.Place}`]: "PLACE",
  [`/${PermissionMenuKey.Gallery}`]: "GALLERY",
  [`/${PermissionMenuKey.Discover}`]: "DISCOVER",
  [`/${PermissionMenuKey.gioiThieu}/:slug`]: "WEBSITE",
  [`/${PermissionMenuKey.tinTuc}/:slug`]: "WEBSITE",
  "/sign-in": "LOGIN",
  default: "PLACE",
};

export const ModeAuthorizeEnum = {
  view: "view",
  access: "access",
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  // getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center",
  },
  variant: "menu",
};

export function hasChildren(item) {
  const { items: children } = item;

  if (children === undefined) {
    return false;
  }

  if (children.constructor !== Array) {
    return false;
  }

  if (children.length === 0) {
    return false;
  }

  return true;
}

export function convertNumbersToStrings(obj) {
  for (const key in obj) {
    if (typeof obj[key] === "number") {
      obj[key] = obj[key].toString();
    } else if (typeof obj[key] === "object") {
      convertNumbersToStrings(obj[key]);
    }
  }
  return obj;
}

export function PaperComponent(props) {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

const allowedFileTypes = {
  ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  ".xls": "application/vnd.ms-excel", // .xls
  ".jpeg": "image/jpeg",
  ".jpg": "image/jpg",
  ".png": "image/png",
  ".gif": "image/gif",
  ".bmp": "image/bmp",
  ".svg": "image/svg+xml", // image/*
  ".doc": "application/msword",
  ".docx":
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .doc, .docx
  ".pdf": "application/pdf", // .pdf
  ".zip": "application/zip",
  ".rar": "application/x-rar-compressed", // .zip, .rar
};

const allowedFileTypesImage3d = {
  ".jpeg": "image/jpeg",
  ".jpg": "image/jpg",
  ".png": "image/png",
  ".gif": "image/gif",
  ".bmp": "image/bmp",
  ".svg": "image/svg+xml", // image/*
  ".psd": "image/vnd.adobe.photoshop", // .psd (nếu cần)
  ".exr": "image/x-exr", // .exr
  ".hdr": "image/vnd.radiance", // .hdr
};

const allowedFileTypesImage = {
  ".jpeg": "image/jpeg",
  ".jpg": "image/jpg",
  ".png": "image/png",
  ".gif": "image/gif",
  ".bmp": "image/bmp",
  ".svg": "image/svg+xml", // image/*
};

const allowedFileTypes3d = {
  ".glb": "application/octet-stream",
  ".gltf": "application/octet-stream",
};

const allowedFileTypesVideo = [
  "video/mp4",
  "video/x-msvideo",
  "video/quicktime",
]; // MIME types for .mp4, .avi, .mov

const allowedFileTypesAudio = ["audio/mpeg", "audio/wav", "audio/aac"]; // MIME types for .mp3, .wav, .aac

const allowedTypesImage = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/svg+xml", // image/*
];

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export {
  API_URL,
  APP_URL,
  MenuProps,
  allowedFileTypes,
  allowedFileTypesImage,
  allowedFileTypes3d,
  allowedFileTypesVideo,
  allowedFileTypesAudio,
  allowedTypesImage,
  allowedFileTypesImage3d,
  VisuallyHiddenInput,
  ClientId_Google,
};

export const checkUrlTep = (string) => {
  let result = string;
  if (string.includes("/media/")) {
    result = string.replace("/media/", "");
  }
  return result;
};

export const stripHtml = (html) => {
  if (!html) return "";

  // Tạo một textarea để decode HTML entities
  const textArea = document.createElement("textarea");
  textArea.innerHTML = html;
  let decoded = textArea.value;

  // Loại bỏ thẻ HTML và làm sạch chuỗi
  return decoded
    .replace(/<[^>]+>/g, "") // Loại bỏ tất cả thẻ HTML
    .replace(/&nbsp;/g, " ") // Thay thế &nbsp; bằng khoảng trắng
    .trim(); // Loại bỏ khoảng trắng thừa
};

export const removeInlineStyles = (html) => {
  if (!html) return "";
  return html.replace(/style="[^"]*"/g, ""); // Xóa tất cả các style inline
};
// Hàm format ngày thành dd/MM/yyyy
export const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr; // Trả về nguyên bản nếu không phải ngày hợp lệ
  return date.toLocaleDateString("vi-VN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};
